export const PENDING = "PENDING";
export const IN_PROGRESS = "IN_PROGRESS";
export const COMPLETED = "COMPLETED";
export const CANCELLED = "CANCELLED";
